import { StarIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/classes";
import { ChevronRightIcon } from "@heroicons/react/24/solid";

/* Prop Types */
interface CopilotButtonProps {
  isLoading?: boolean;
  className?: string;
  onClick?: () => void;
  showStar?: boolean;
  showChevron?: boolean;
  disabled?: boolean;
}

/*
 * CopilotButton component
 */
export const CopilotButton = ({ isLoading, className, onClick, showStar, showChevron, disabled }: CopilotButtonProps) => {
  /* Render */
  return (
    <Button variant={disabled ? "secondary" : "gradient"} disabled={isLoading || disabled} className={cn("", className)} onClick={onClick}>
      {showStar && <StarIcon className="size-3.5" />}
      Copilot
      {showChevron && <ChevronRightIcon className="size-4.5" />}
    </Button>
  );
};
